type Size = 'sm' | 'md' | 'lg' | 'xl';

const sizeStyles: Record<Size, string> = {
  sm: 'text-xs px-2 py-[3px]',
  md: 'text-sm px-2.5 py-1',
  lg: 'text-base px-3.5 py-1.5',
  xl: 'text-[22px] px-[18px] py-2.5',
};

interface C2GoTagProps {
  slug: string;
  size?: Size;
  className?: string;
}

export default function C2GoTag({ slug, size = 'md', className = '' }: C2GoTagProps) {
  return (
    <span
      className={[
        'font-mono font-semibold text-ink bg-bg-alt border border-hairline rounded-sm inline-block',
        sizeStyles[size],
        className,
      ].join(' ')}
    >
      <span className="text-ink-muted">go/</span>
      {slug}
    </span>
  );
}
